export { CarPulseLogo, default } from './car_pulse_logo';
